import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    BoxedRow,
    IconCallLandlineRegular,
    IconDataBonusRegular,
    IconLockClosedRegular,
    IconMobileDeviceRegular,
    IconSmsRegular,
    Text1,
    Text2,
    skinVars,
} from '@telefonica/mistica';
import ExtaMobile from '../ExtraMobile';
import { useTranslation } from 'react-i18next';
import '../../translations/i18n';
import navigateParams from '../../utils/navigation/navigateParams';
import { useLocation, useNavigate } from 'react-router-dom';
import { conversionToGB, formatMobileNumber } from '../../utils/dataTransformation/unitsConversion';
import { useDispatch } from 'react-redux';
import { showSnackbar, showStopper } from '../../utils/store/features/user';
import { managementEnvironment } from '../../utils/dataTransformation/environments';
import useUserlight from '../../hooks/useUserLight';
import ExtraCallOrSms from '../ExtraCallsOrSms';
import { useConfigureLineContext } from '../../context/configure-line-context/ConfigureLineContext';

export interface IMobileSectionBoxed {
    data?: any;
    title?: string;
    isDataBonus?: boolean;
    navigate?: any;
    typeClicked?: any;
}

const MobileSectionBoxed: React.FC<IMobileSectionBoxed> = ({ data }: IMobileSectionBoxed) => {
    const { t } = useTranslation();
    const { state } = useLocation();
    const navigate = useNavigate();
    const { blocked } = useConfigureLineContext();
    const dispatch = useDispatch();
    const storage = localStorage.getItem('storage');
    const isLight = useUserlight();
    const number = window.localStorage.getItem('mc-number');
    let productPsId: string = '';
    let storageJson: any;
    if (storage && storage !== 'undefined') {
        storageJson = JSON.parse(storage);
        productPsId = storageJson.productPsId;
    } else {
        storageJson = data;
        productPsId = data?.productPsId;
    }

    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);
    const consumptionsDisabled = managementEnvironment().VITE_STOPPER_CONSUMPTIONS_DISABLED;

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const sendToNative = (detailType: any) => {
        if (consumptionsDisabled) {
            dispatch(showStopper());
        } else {
            const isOtherLine = number !== storageJson.number;

            if (isLight && isOtherLine) {
                dispatch(showSnackbar());
            } else {
                const type = 'modeFlow-backgroundBlue';
                const url = '/mobile/consumption';
                const title = 'Detalle de consumo';
                const queryParams = { productPsId: productPsId };
                storageJson.detailType = detailType;
                storageJson.isMobile = true;
                localStorage.setItem('storage', JSON.stringify(storageJson));
                if (navigateParams(type, url, queryParams, storageJson, title)) {
                    navigate(url + '?productPsId=' + productPsId, { state });
                    sessionStorage.setItem(
                        'breadcrumb',
                        JSON.stringify([{ title: state || data?.number, url: window.location.href }]),
                    );
                }
            }
        }
    };

    return (
        <>
            <div
                className='mobile-section-boxed-component'
                style={
                    data?.dataSharing
                        ? { gridTemplateAreas: `'data data' 'call sms'` }
                        : !data?.dataBonus
                          ? {
                                gridTemplateAreas:
                                    windowWidth >= 1220
                                        ? `'data data  call sms'`
                                        : windowWidth >= 1024
                                          ? `'data data' 'call sms'`
                                          : windowWidth >= 768
                                            ? `'data data data data data data data data data data data data data data data data data data data data data data call sms'`
                                            : `'data data' 'call sms'`,
                            }
                          : { gridTemplateAreas: `'data bonus' 'call sms'` }
                }
            >
                {data?.dataSharing ? (
                    <div
                        className='mobile-section-boxed-component-data'
                        onClick={() => {
                            sendToNative('DATA');
                        }}
                    >
                        <BoxedRow
                            title={''}
                            headline={
                                <Text1 regular color={skinVars.colors.neutralMedium}>
                                    {t('mobileData')}
                                </Text1>
                            }
                            right={
                                blocked ? (
                                    <IconLockClosedRegular color={skinVars.colors.controlError} size={24} />
                                ) : (
                                    <IconMobileDeviceRegular />
                                )
                            }
                            extra={
                                <ExtaMobile
                                    maxNumber={data?.dataSharing?.max}
                                    currentNumber={data?.dataSharing?.current}
                                    unit={data?.dataSharing?.unit}
                                    maxGigs={
                                        <Text2 regular color={skinVars.colors.textSecondary}>
                                            {`${t('of')} ${conversionToGB(
                                                data?.dataSharing?.unit,
                                                data?.dataSharing?.max,
                                                0,
                                            )} `}
                                        </Text2>
                                    }
                                    dataBonus={data?.dataBonus && true}
                                    isBlocked={blocked}
                                ></ExtaMobile>
                            }
                        ></BoxedRow>
                    </div>
                ) : !data?.dataBonus ? (
                    windowWidth >= 1024 ? (
                        <div
                            className='mobile-section-boxed-component-data'
                            onClick={() => {
                                sendToNative('DATA');
                            }}
                        >
                            <BoxedRow
                                title={''}
                                headline={
                                    <Text1 regular color={skinVars.colors.neutralMedium}>
                                        {t('mobileData')}
                                    </Text1>
                                }
                                right={
                                    blocked ? (
                                        <IconLockClosedRegular color={skinVars.colors.controlError} size={24} />
                                    ) : (
                                        <IconMobileDeviceRegular size={24} />
                                    )
                                }
                                extra={<ExtraCallOrSms text={t('gigs')} data={data?.data} isBlocked={blocked} />}
                            />
                        </div>
                    ) : (
                        <div
                            className='mobile-section-boxed-component-data'
                            style={{
                                paddingRight:
                                    windowWidth >= 1024 ? '0px' : windowWidth >= 768 && !data?.dataBonus ? '16px' : '',
                            }}
                            onClick={() => {
                                sendToNative('DATA');
                            }}
                        >
                            <BoxedRow
                                title={''}
                                headline={
                                    <Text1 regular color={skinVars.colors.neutralMedium}>
                                        {t('mobileData')}
                                    </Text1>
                                }
                                right={
                                    blocked ? (
                                        <IconLockClosedRegular color={skinVars.colors.controlError} size={24} />
                                    ) : (
                                        <IconMobileDeviceRegular />
                                    )
                                }
                                extra={
                                    <ExtaMobile
                                        maxNumber={data?.data?.max}
                                        currentNumber={data?.data?.current}
                                        unit={data?.data?.unit}
                                        maxGigs={
                                            <Text2 regular color={skinVars.colors.textSecondary}>
                                                {t('of') + ` ${conversionToGB(data?.data?.unit, data?.data?.max, 0)} `}
                                            </Text2>
                                        }
                                        isBlocked={blocked}
                                    ></ExtaMobile>
                                }
                            ></BoxedRow>
                        </div>
                    )
                ) : (
                    <>
                        <div
                            className='mobile-section-boxed-component-data'
                            onClick={() => {
                                sendToNative('DATA');
                            }}
                        >
                            <BoxedRow
                                title=''
                                headline={
                                    <Text1 regular color={skinVars.colors.neutralMedium}>
                                        {t('mobileData')}
                                    </Text1>
                                }
                                right={
                                    blocked ? (
                                        <IconLockClosedRegular color={skinVars.colors.controlError} size={24} />
                                    ) : (
                                        <IconMobileDeviceRegular size={24} />
                                    )
                                }
                                extra={<ExtraCallOrSms text={t('gigs')} data={data?.data} isBlocked={blocked} />}
                            />
                        </div>
                        <div
                            className='mobile-section-boxed-component-extraBonus'
                            onClick={() => {
                                sendToNative('DATA');
                            }}
                        >
                            <BoxedRow
                                title=''
                                headline={
                                    <Text1 regular color={skinVars.colors.neutralMedium}>
                                        {t('extrabonds')}
                                    </Text1>
                                }
                                right={
                                    blocked ? (
                                        <IconLockClosedRegular color={skinVars.colors.controlError} size={24} />
                                    ) : (
                                        <IconDataBonusRegular size={24} />
                                    )
                                }
                                extra={<ExtraCallOrSms text={t('gigs')} data={data?.dataBonus} isBlocked={blocked} />}
                            />
                        </div>
                    </>
                )}

                <div
                    className='mobile-section-boxed-component-call'
                    onClick={() => {
                        sendToNative('VOICE');
                    }}
                >
                    <BoxedRow
                        title=''
                        headline={
                            <Text1 regular color={skinVars.colors.neutralMedium}>
                                {t('calls')}
                            </Text1>
                        }
                        right={
                            blocked ? (
                                <IconLockClosedRegular color={skinVars.colors.controlError} size={24} />
                            ) : (
                                <IconCallLandlineRegular size={24} />
                            )
                        }
                        extra={<ExtraCallOrSms text={t('minutes')} data={data?.voice} isBlocked={blocked} />}
                    />
                </div>
                <div
                    className='mobile-section-boxed-component-sms'
                    onClick={() => {
                        sendToNative('SMS');
                    }}
                >
                    <BoxedRow
                        title=''
                        headline={
                            <Text1 regular color={skinVars.colors.neutralMedium}>
                                {t('messages')}
                            </Text1>
                        }
                        right={
                            blocked ? (
                                <IconLockClosedRegular color={skinVars.colors.controlError} size={24} />
                            ) : (
                                <IconSmsRegular size={24} />
                            )
                        }
                        extra={<ExtraCallOrSms text={t('sms')} data={data?.sms} isBlocked={blocked} />}
                    />
                </div>
            </div>
        </>
    );
};

export default MobileSectionBoxed;
